import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HyperLink from 'components/Core/HyperLink';
import { STGlyph } from 'components/Brand/Logos/STGlyph';

const HomeSystemSection = ({ background, title, description, features, ...otherProps }) => {
  return (
    <SectionHomeSystem {...otherProps}>
      <div className="section-home-system--container">
        <div className="section-home-system--diagram-container">
          <div className="circle-container">
            {features.map((feature, index) => {
              return (
                <HyperLink
                  data-position="Home - Wheel Nav Element"
                  href={feature.link}
                  className="feature-link"
                  key={index}
                >
                  {feature.feature}
                </HyperLink>
              );
            })}
            <div className="logo">
              <STGlyph />
            </div>
          </div>
        </div>
        <div className="section-home-system--text-container">
          {title && <h2 className="section-home-system--title">{title}</h2>}
          {description && <p className="section-home-system--description">{description}</p>}
          {otherProps.cta}
        </div>
      </div>
    </SectionHomeSystem>
  );
};

HomeSystemSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  features: PropTypes.array,
};

const SectionHomeSystem = styled.div`
  padding: 0 28px;
  background: ${props => props.background};
  .button--button {
    margin-top: 25px;
    @media (max-width: 576px) {
      margin: 25px auto 0px;
    }
  }
  .section-home-system--container {
    padding: 104px 0;
    display: flex;
    align-items: center;
    max-width: 1226px;
    margin: 0 auto;
    justify-content: space-between;

    .section-home-system--diagram-container {
      width: 100%;
      padding: 0 62px;

      .circle-container {
        position: relative;
        width: 540px;
        height: 540px;
        padding: 86.8px;
        border: 10px solid #e5f7ff;
        border-radius: 50%;
        /*margin: 0 auto;*/

        .logo {
          background: var(--blue-video);
          width: 168px;
          height: 168px;
          border-radius: 50%;
          padding: 40px;
          top: 50%;
          left: 50%;
          position: absolute;
          margin: -84px;

          svg {
            width: 100%;
            height: 100%;
          }
        }

        .feature-link {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 124px;
          height: 124px;
          background: var(--white-color);
          border-radius: 50%;
          box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
          margin: -62px;
          font-size: 18px;
          line-height: 18px;
          text-align: center;
          letter-spacing: -0.02em;
          color: #0096dc;
          transition: box-shadow 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);

          &:nth-child(3) {
            transform: translate(270px);
          }

          &:nth-child(4) {
            transform: rotate(30deg) translate(270px) rotate(-30deg);
          }

          &:nth-child(5) {
            transform: rotate(60deg) translate(270px) rotate(-60deg);
          }

          &:nth-child(6) {
            transform: rotate(90deg) translate(270px) rotate(-90deg);
          }

          &:nth-child(7) {
            transform: rotate(120deg) translate(270px) rotate(-120deg);
          }

          &:nth-child(8) {
            transform: rotate(150deg) translate(270px) rotate(-150deg);
          }

          &:nth-child(9) {
            transform: rotate(180deg) translate(270px) rotate(-180deg);
          }

          &:nth-child(10) {
            transform: rotate(210deg) translate(270px) rotate(-210deg);
          }

          &:nth-child(11) {
            transform: rotate(240deg) translate(270px) rotate(-240deg);
          }

          &:nth-child(12) {
            transform: rotate(270deg) translate(270px) rotate(-270deg);
          }

          &:nth-child(1) {
            transform: rotate(300deg) translate(270px) rotate(-300deg);
          }

          &:nth-child(2) {
            transform: rotate(330deg) translate(270px) rotate(-330deg);
          }

          &:hover {
            box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
          }
        }
      }
    }

    .section-home-system--text-container {
      width: 100%;
      padding-left: 30px;
      max-width: 505px;

      .section-home-system--title {
        font-size: 49px;
        line-height: 110%;
        letter-spacing: -0.04em;
        color: var(--normal-title-color);
      }

      .section-home-system--description {
        font-weight: 500;
        font-size: 20px;
        line-height: 150%;
        color: var(--normal-description-color);
        padding: 0;
        margin: 24px 0 0;
      }
    }
  }

  @media (max-width: 991px) {
    .section-home-system--container {
      flex-direction: column-reverse;
      .section-home-system--diagram-container {
        margin-top: 100px;

        .circle-container {
          margin: 0 auto;
        }
      }

      .section-home-system--text-container {
        max-width: 100%;
        text-align: center;
        padding: 0;
      }
    }
  }

  @media (max-width: 768px) {
    .section-home-system--container {
      padding: 48px 0;

      .section-home-system--diagram-container {
        margin-top: 2px;
        padding: 0;

        .circle-container {
          display: none;
        }
      }

      .section-home-system--text-container {
        .section-home-system--title {
          font-size: 29px;
          letter-spacing: -0.03em;
        }

        .section-home-system--description {
          font-size: 17px;
          max-width: 590px;
          margin: 16px auto 0;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-home-system--container {
    }
  }
`;

export default HomeSystemSection;
